import { render, staticRenderFns } from "./SearchProductCategoryInput.vue?vue&type=template&id=3146059c&"
import script from "./SearchProductCategoryInput.vue?vue&type=script&lang=js&"
export * from "./SearchProductCategoryInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports